import { IRExp } from '@/types/interfaces';

export default {
  expression: /([^0-9a-zA-Z-,./&()$:%+!? ]|\/\/|&&){1,200}/g,
  name: 'occupation',
} as IRExp;
